import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, Bell, Music, PartyPopper, Trophy } from 'lucide-react';

interface EmptyEventsStateProps {
  city?: string | null;
}

const EmptyEventsState: React.FC<EmptyEventsStateProps> = ({ city }) => {
  const suggestedCategories = [
    { name: 'Shows', icon: Music, slug: 'shows' },
    { name: 'Festas', icon: PartyPopper, slug: 'festas' },
    { name: 'Esportes', icon: Trophy, slug: 'sports' }
  ];

  return (
    <div className="text-center py-16 bg-gray-50 rounded-2xl">
      <div className="max-w-md mx-auto">
        <div className="w-20 h-20 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Calendar className="h-10 w-10 text-indigo-600" />
        </div>
        
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          {city ? `Nenhum evento em ${city}` : 'Nenhum evento encontrado'}
        </h3>
        
        <p className="text-gray-600 mb-8 leading-relaxed">
          {city 
            ? `Não encontramos eventos próximos em ${city} no momento. Que tal explorar outras opções?`
            : 'Não encontramos eventos que correspondam aos seus critérios. Tente ajustar sua busca.'
          }
        </p>

        <div className="space-y-4 mb-8">
          <Link
            to="/events"
            className="inline-flex items-center justify-center w-full px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            <MapPin className="h-5 w-5 mr-2" />
            Ver eventos em outras cidades
          </Link>
          
          {city && (
            <button className="inline-flex items-center justify-center w-full px-6 py-3 bg-white hover:bg-gray-50 text-gray-700 font-semibold rounded-xl border-2 border-gray-200 hover:border-gray-300 transition-all duration-200">
              <Bell className="h-5 w-5 mr-2" />
              Criar alerta para {city}
            </button>
          )}
        </div>

        <div>
          <p className="text-sm font-medium text-gray-700 mb-4">Ou explore por categoria:</p>
          <div className="flex justify-center space-x-3">
            {suggestedCategories.map((category) => (
              <Link
                key={category.slug}
                to={`/events?category=${category.slug}`}
                className="flex items-center space-x-2 px-4 py-2 bg-white hover:bg-indigo-50 text-gray-700 hover:text-indigo-600 rounded-lg border border-gray-200 hover:border-indigo-200 transition-all duration-200 text-sm font-medium"
              >
                <category.icon className="h-4 w-4" />
                <span>{category.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyEventsState;